<template>
  <div class="domain__menu" ref="lnb">
    <ui-logo :isEditMode="isEditMode" :target="'domain'" :is-logo-white="false"/>
    <p v-if="isEditMode" class="edit-mode-title" :class="{ab: isABPlan}">{{ $t('common.editMode') }}</p>
    <span class="domain__menu-shadow" :class="{ scrolled: !isContentHeaderScrollTop }"></span>
    <div class="domain__list--group" :class="{ 'has-footer': hasFooter }">
      <div class="domain__list--title">
        <span class="icon-wrap">
          <i class="icon icon--analysis-reports" />
        </span>
        <p>Analysis Reports</p>
      </div>
      <ul class="domain__list--wrap"
          ref="domainList"
          :class="{ 'scrolled': !isContentHeaderScrollTop, 'edit-mode': isEditMode, ab: isABPlan, 'scrollbar': this.isScrollBar && isWindows }"
          @scroll="onDomainListScroll">
        <li v-for="(item, index) in domains"
            :key="index"
            :class="{ fold: item.isExpanded, hide: item.sid !== currentSid && isEditMode }"
            class="domain-item"
            @click="onDomainClick(item)"
        >
          <p
             class="domain-text"
             :title="item.domain"
             :class="{ on: item.sid === currentSid, 'edit-mode': isEditMode }">
            <i v-if="item.samplingRate < 100 && item.samplingRate !== null" class="icon icon--sampling" />
            <span class="domain-text__name">{{ item.domain }}</span>
            <i class="icon icon--toggle-slide14"></i>
          </p>
          <ul class="category__list--wrap" v-if="item.sid === currentSid" @click.stop>
            <li v-for="(category, index) in domainCategories" :key="index"
              class="category-item ellipsis"
              :class="{
                'edit-mode': isEditMode,
                active: currentDashboardCategory.index === index &&
                currentDashboardCategory.categoryId === category._id
              }"
              @click="onUpdateCurrentCategoryIndex(index, category._id)">
              <template v-if="category._id === '__shared__'">{{ $t('dashboard.pageShare.folderTitle') }}</template>
              <template v-else>{{ category._id }}</template>
              <i v-if="hasSharedApply(category) || category._id === '__shared__'" class="icon icon--shared"></i>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div v-if="hasFooter" class="domain__menu-footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { EventBus } from '@/libs/event-bus'
import UiLogo from '@/components/ui/UiLogo.vue'

export default {
  name: 'DomainList',
  data () {
    return {
      selectedItem: {},
      isContentHeaderScrollTop: true,
      isScrollBar: false
    }
  },
  components: {
    UiLogo
  },
  props: [
    'isEditMode',
    'domains',
    'currentSid',
    'domainCategories',
    'isHorizen',
    'hasFooter'
  ],
  computed: {
    ...mapState([
      'currentDashboardCategory',
      'isABPlan',
      'applyData'
    ]),
    isWindows () {
      return navigator.userAgent.includes('Windows') && !navigator.userAgent.includes('Whale')
    }
  },
  mounted () {
    this.checkScroll()
    EventBus.$on('scrollUpdateCurrentCategoryIndex', (index, categoryId) => {
      this.setCurrentDashboardCategory({
        categoryId,
        index
      })
    })
  },
  methods: {
    ...mapMutations([
      'setCurrentDashboardCategory'
    ]),
    checkScroll () {
      this.$nextTick(() => {
        const el = this.$refs.domainList
        this.isScrollBar = el.scrollHeight > el.clientHeight
      })
    },
    hasSharedApply (category) {
      let hasSharedApply = false
      for (const apply of category.applies) {
        if (apply.shared) hasSharedApply = true
      }
      return hasSharedApply
    },
    onDomainClick (item) {
      this.$emit('onDomainSelect', item)
    },
    onDomainListScroll (event) {
      this.isContentHeaderScrollTop = event.currentTarget.scrollTop === 0
    },
    onUpdateCurrentCategoryIndex (index, categoryId) {
      this.setCurrentDashboardCategory({
        categoryId,
        index
      })
      EventBus.$emit('updateCurrentCategoryIndex', index)
    }
  }
}
</script>

<style lang="scss" scoped>
.domain__menu {
  .edit-mode-title {
    font-size: 22px;
    font-weight: 600;
    line-height: 1;
    color: #289eef;
    position: absolute;
    top: 88px;
    left: 12px;

    &.ab {
      top: 137px;
    }
  }

  .domain__menu-shadow.scrolled {
    content: '';
    display: block;
    width: 210px;
    height: 12px;
    background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.18), rgba(0, 0, 0, 0));
    position: relative;
    top: 46px;
    left: 0;
    z-index: 10;
    pointer-events: none;
  }

  .domain__list--group {
    top: 201px;
    border-top: 1px solid #AAA;
    border-bottom: 1px solid #AAA;
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    width: 210px;

    &.has-footer {
      border-bottom: 0;

      .domain__list--wrap {
        max-height: calc(100vh - 515px);
      }
    }

    .domain__list--title {
      padding: 12px 10px 14px 10px;
      display: flex;
      align-items: center;
      gap: 4px;
      width: 210px;
      box-sizing: border-box;

      .icon-wrap {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
      }

      p {
        color: #222;
        font-size: 14px;
        font-weight: 600;
        line-height: 100%; /* 14px */
      }
    }
    .domain__list--wrap {
      box-sizing: border-box;
      min-height: 100%;
      max-height: calc(100vh - 244px);
      overflow-y: auto;
      width: 176px;

      &.edit-mode {
        top: 136px;

        &.ab {
          top: 192px;
        }
      }

      &.scrollbar {
        .domain-item {
          padding: 8px 3px 8px 9px;
        }
      }

      .domain-item {
        min-height: 48px;
        padding: 18px 18px 18px 0;
        box-sizing: border-box;
        cursor: pointer;

        &:first-child {
          border-top: 1px dashed #CDCDCD;
        }
        &:not(:last-child) {
          border-bottom: 1px dashed #CDCDCD;
        }

        &.fold {
          .category__list--wrap {
            display: block;
          }
          .domain-text .icon--toggle-slide14 { transform: translateY(-50%) rotate(180deg); }
        }

        &.hide {
          display: none;
          opacity: 0;
        }

        .category__list--wrap {
          display: none;
        }

        .domain-text {
          pointer-events: inherit;
          position: relative;
          display: inline-flex;
          align-items: center;
          gap: 4px;
          max-width: 158px;
          width: 100%;
          height: 100%;
          padding-right: 43px;
          box-sizing: border-box;
          color: #444;
          font-size: 12px;
          font-weight: 400;
          line-height: 100%; /* 12px */

          &.on {
            font-weight: 600;
            color: $brandColor;
          }
          &.on.edit-mode {
            color: #289eef;
          }

          .domain-text__name {
            flex: 1;
            min-width: 0;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .icon.icon--toggle-slide14 {
            position: absolute;
            top: 50%;
            right: 0;
            transform: translateY(-50%);
          }
        }
      }
    }
  }

  .domain__menu-footer {
    position: absolute;
    left: 11px;
    bottom: 12px;
    width: 186px;
    height: 248px;
  }

  .category__list--wrap {
    .category-item {
      color: #444444;
      margin-top: 9px;
      width: 100%;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      line-height: 100%; /* 12px */
      box-sizing: border-box;
      cursor: pointer;
      position: relative;
      padding: 4px 8px 5px 7px;

      &:first-child {
        margin-top: 16px;
      }

      &:not(.active):hover {
        background-color: #ebebeb;
      }
      &.active {
        background-color: $brandColor;
        color: #fff;

        .icon {
          background-image: url(../../assets/img/dashboard/icon_shared_hover.svg);
        }
      }
      &.active.edit-mode {
        background-color: #289eef;
      }

      .icon {
        position: absolute;
        top: 50%;
        right: 7px;
        transform: translateY(-50%);
      }
    }
  }
}
</style>
